
export default function FeaturedAuctions() {
  const featuredAuctions = [
    {
      id: 1,
      title: 'مزاد السيارات الكلاسيكية',
      description: 'مجموعة نادرة من السيارات الكلاسيكية',
      startDate: '15 ديسمبر 2024',
      itemCount: '25 قطعة',
      image: 'https://www.soumqatar.com/uploads/featured/classic-cars-auction.jpg'
    },
    {
      id: 2,
      title: 'مزاد المجوهرات الفاخرة',
      description: 'قطع مجوهرات استثنائية ونادرة',
      startDate: '20 ديسمبر 2024',
      itemCount: '18 قطعة',
      image: 'https://www.soumqatar.com/uploads/featured/luxury-jewelry-auction.jpg'
    },
    {
      id: 3,
      title: 'مزاد الفنون التراثية',
      description: 'لوحات ومنحوتات من التراث القطري',
      startDate: '25 ديسمبر 2024',
      itemCount: '12 قطعة',
      image: 'https://www.soumqatar.com/uploads/featured/heritage-arts-auction.jpg'
    }
  ];

  return (
    <div className="px-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">المزادات المميزة</h3>
        <button className="text-yellow-400 text-sm font-medium">عرض الكل</button>
      </div>
      
      <div className="space-y-4">
        {featuredAuctions.map((auction) => (
          <div key={auction.id} className="bg-gray-900 rounded-xl overflow-hidden">
            <img
              src={auction.image}
              alt={auction.title}
              className="w-full h-32 object-cover object-top"
              onError={(e) => {
                // Fallback images
                const target = e.target as HTMLImageElement;
                const fallbackImages: { [key: number]: string } = {
                  1: 'https://public.readdy.ai/ai/img_res/9727fa5d1e894d6e23a9ebcbe810a2e4.jpg',
                  2: 'https://readdy.ai/api/search-image?query=Luxury%20jewelry%20collection%20display%2C%20premium%20diamonds%20and%20gold%2C%20elegant%20jewelry%20presentation%2C%20sophisticated%20lighting%2C%20high-end%20accessories%2C%20professional%20jewelry%20photography%2C%20luxury%20showcase%2C%20golden%20accents&width=343&height=150&seq=featured2&orientation=landscape',
                  3: 'https://readdy.ai/api/search-image?query=Traditional%20Qatari%20heritage%20art%20paintings%20and%20sculptures%2C%20cultural%20artwork%20display%2C%20elegant%20art%20gallery%2C%20sophisticated%20lighting%2C%20premium%20art%20collection%2C%20professional%20art%20photography%2C%20cultural%20heritage%2C%20artistic%20elegance&width=343&height=150&seq=featured3&orientation=landscape'
                };
                target.src = fallbackImages[auction.id] || fallbackImages[1];
              }}
            />
            
            <div className="p-4">
              <h4 className="font-semibold mb-1">{auction.title}</h4>
              <p className="text-sm text-gray-400 mb-3">{auction.description}</p>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-gray-400">يبدأ في</p>
                  <p className="text-sm font-medium text-yellow-400">{auction.startDate}</p>
                </div>
                
                <div className="text-left">
                  <p className="text-xs text-gray-400">عدد القطع</p>
                  <p className="text-sm font-medium">{auction.itemCount}</p>
                </div>
                
                <button className="bg-gray-800 text-white px-4 py-2 rounded-full text-sm font-medium">
                  تذكيري
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
